<template>
  <div class="coming_soon">
    <img class="show-for-md image__fit" style="width:100%" :src="inMaintenance.pc" />
    <img class="hide-for-md image__fit" style="width:100%" :src="inMaintenance.h5" />
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  computed: {
    inMaintenance() {
      let obj = {
        h5: '',
        pc: ''
      };
      try {
        if(this.$store.state.siteConfig?.IS_TENANCE?.tenance) {
          let _obj = JSON.parse(this.$store.state.siteConfig.IS_TENANCE.tenance);
          obj = _obj
        }
      } catch (error) {
        console.warn(error)
      }
      return obj;
    }
  }
}
</script>

<style lang="scss">
.coming_soon {
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
@media screen and (max-width: 47.9375em) {
  .hide-for-xs-only {
    display: none !important;
  }
}
@media screen and (max-width: 0em), screen and (min-width: 48em) {
  .show-for-xs-only {
    display: none !important;
  }
}
@media screen and (min-width: 48em) {
  .hide-for-sm {
    display: none !important;
  }
}
@media screen and (max-width: 47.9375em) {
  .show-for-sm {
    display: none !important;
  }
}
@media screen and (min-width: 48em) and (max-width: 63.9375em) {
  .hide-for-sm-only {
    display: none !important;
  }
}
@media screen and (max-width: 47.9375em), screen and (min-width: 64em) {
  .show-for-sm-only {
    display: none !important;
  }
}
@media screen and (min-width: 64em) {
  .hide-for-md {
    display: none !important;
  }
}
@media screen and (max-width: 63.9375em) {
  .show-for-md {
    display: none !important;
  }
}
@media screen and (min-width: 64em) and (max-width: 74.9375em) {
  .hide-for-md-only {
    display: none !important;
  }
}
@media screen and (max-width: 63.9375em), screen and (min-width: 75em) {
  .show-for-md-only {
    display: none !important;
  }
}
@media screen and (min-width: 75em) {
  .hide-for-lg {
    display: none !important;
  }
}
@media screen and (max-width: 74.9375em) {
  .show-for-lg {
    display: none !important;
  }
}
@media screen and (min-width: 75em) {
  .hide-for-lg-only {
    display: none !important;
  }
}
@media screen and (max-width: 74.9375em) {
  .show-for-lg-only {
    display: none !important;
  }
}
.hide-for-portrait,
.show-for-landscape {
  display: block !important;
}
@media screen and (orientation: landscape) {
  .hide-for-portrait,
  .show-for-landscape {
    display: block !important;
  }
}
@media screen and (orientation: portrait) {
  .hide-for-portrait,
  .show-for-landscape {
    display: none !important;
  }
}
.hide-for-landscape,
.show-for-portrait {
  display: none !important;
}
@media screen and (orientation: landscape) {
  .hide-for-landscape,
  .show-for-portrait {
    display: none !important;
  }
}
@media screen and (orientation: portrait) {
  .hide-for-landscape,
  .show-for-portrait {
    display: block !important;
  }
}

@media (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .coming_soon .image__fit {
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
